import { render, staticRenderFns } from "./registrati.vue?vue&type=template&id=2ddf0053"
import script from "./registrati.vue?vue&type=script&lang=js"
export * from "./registrati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports